import type { OptionPriceValue } from "../../../admin/products/productsApi";
import { Price } from "../../../misc/price";
import type { SelectedProductOption } from "./getOptionPrice";
import { getOptionPrice } from "./getOptionPrice";

export function getProductPrice(
  selectedOptions: SelectedProductOption[],
  exchangeRate: number | undefined,
  margin: number,
  prices: Record<string, { price: OptionPriceValue }>,
): Price {
  if (selectedOptions.some((o) => !o.id)) {
    return new Price("INVALID");
  }
  return selectedOptions
    .map((so) => {
      const priceListPrice = so.id ? prices[so.id]?.price : undefined;
      const optionPrice = getOptionPrice(so, priceListPrice, exchangeRate, margin);
      return optionPrice.multiply(so.quantity);
    })
    .reduce((prev, curr) => prev.add(curr), new Price(0));
}
